export interface ComplexityByReferenceWithScore {
  key: string;
  complexity: string | undefined;
  scoring: {
    score: number | null;
    max_score: number;
    question_scores: {
      max_score: number;
      score: number | null;
    }[];
  };
}

export const isPassed = (scoring?: { score: number | null; max_score: number }): boolean =>
  scoring != null && scoring.score !== null && scoring.score === scoring.max_score;

// Which individual problems are solved. Callers snapshot this into state at the two moments a score
// is meaningful — session restore and "Check answer" — rather than reading Learnosity while
// rendering, where the score is already populated the instant a response changes.
export const getPassedReferences = (complexityByReferenceWithScore: ComplexityByReferenceWithScore[]): string[] =>
  complexityByReferenceWithScore.filter(item => isPassed(item.scoring)).map(item => item.key);

export const getPassedByLevel = (complexityByReferenceWithScore: ComplexityByReferenceWithScore[]) => {
  const lowDiffPassed = complexityByReferenceWithScore.filter(
    item => item.complexity === '1' && isPassed(item.scoring),
  );
  const midDiffPassed = complexityByReferenceWithScore.filter(
    item => item.complexity === '2' && isPassed(item.scoring),
  );
  const highDiffPassed = complexityByReferenceWithScore.filter(
    item => item.complexity === '3' && isPassed(item.scoring),
  );
  return { low: lowDiffPassed, mid: midDiffPassed, high: highDiffPassed };
};
